import { useQuery } from '@tanstack/react-query';
import { getQuestionnaire } from '../../apis/questionnaires/requests';

export const useQuestionnaire = (questionnaireId?: string) => {
  const { data: questionnaire, isLoading, refetch } = useQuery({
    queryKey: ['questionnaire', questionnaireId],
    queryFn: () => {
      if (!questionnaireId) return Promise.resolve(null);

      return getQuestionnaire(questionnaireId);
    }
  });

  return { questionnaire, isLoading, refetch };
};
